import apiClient from "../apiClient";
import { AdminDashboardStats, AdminStatsFilters } from "@/types/admin.types";
import { logger } from "@/utils/logger";

export const getAdminStats = async (
  filters: AdminStatsFilters
): Promise<AdminDashboardStats> => {
  logger.log("📊 [AdminAPI] Request initiated with filters:", filters);

  try {
    // Using relative path without leading slash to let axios handle baseURL correctly
    // baseURL ends with /, so "teacher/..." becomes ".../teacher/..."
    const data = await apiClient.get<AdminDashboardStats>(
      "teacher/dashboard/admin-stats",
      {
        params: filters,
      }
    );

    logger.log("✅ [AdminAPI] Success:", data);
    return data;
  } catch (error) {
    logger.error("❌ [AdminAPI] Failed:", error);
    throw error;
  }
};
